export default __webpack_public_path__ + "static/Skyweaver-a708f55bd35355190b73c6d7e9fa38e3.png";